import React from 'react';
import PropTypes from 'prop-types';

import { PanelGroup } from 'react-bootstrap';

import UpdatePwdContainer from '../../../containers/UpdatePwdContainer';
import UpdateInfoContainer from '../../../containers/UpdateInfoContainer';
import UpdateEmailContainer from '../../../containers/UpdateEmailContainer';

import PanelComponent from '../../core/PanelComponent/PanelComponent';

import './update-profile.scss';

class UpdateProfilePanelComponent extends React.Component {
    onPanelEntering = (activeKey) => {
        this.setState({
            [`${activeKey}GridUpdate`]: true,
        });
    }

    render() {
        const {
            handleSelect,
        } = this.props;
        let activeKey = this.props.activeKey;
        let currentUserInfo = [this.props.currentUserInfo];

        return <div className="panel-group">
            <PanelGroup accordion id="accordion" onSelect={handleSelect} activeKey={activeKey}>
                {currentUserInfo.map((info, i) => <React.Fragment key={info.uid}>
                    <PanelComponent title='Personal Info'
                        activeKey={activeKey}
                        eventKey='0'
                        eventProps={{
                            onEntering: () => this.onPanelEntering(activeKey),
                        }}>
                        <UpdateInfoContainer />
                    </PanelComponent>
                    <PanelComponent title='Change Password'
                        activeKey={activeKey}
                        eventKey='1'
                        eventProps={{
                            onEntering: () => this.onPanelEntering(activeKey),
                        }}>
                        <UpdatePwdContainer />
                    </PanelComponent>
                    <PanelComponent title='Contact Info'
                        activeKey={activeKey}
                        eventKey='2'
                        eventProps={{
                            onEntering: () => this.onPanelEntering(activeKey),
                        }}>
                        <UpdateEmailContainer />
                    </PanelComponent>
                </React.Fragment>)}
            </PanelGroup>
        </div>;
    }
}

UpdateProfilePanelComponent.propTypes = {
    activeKey: PropTypes.string,
    handleSelect: PropTypes.func.isRequired,
    currentUserInfo: PropTypes.object,
};

export default UpdateProfilePanelComponent;



// WEBPACK FOOTER //
// ./src/components/profile/Profile/UpdateProfilePanelComponent.js